module.exports = __webpack_public_path__ + "img/login-l-dark.ee22c951.png";